import HTTP from '../http'
import Client from './clientModel'

const clientService = {
  get (clientId: string) {
    return clientId
  },
  phoneSearch (phone: string) {
    return HTTP.post('', {
      query: `
        query ($phone: String!) {
          clientPhoneSearch (phone: $phone) {
            id,
            firstName,
            lastName,
            nickName,
            email,
            phone,
            appointments {
              status
            }
          }
        }
      `,
      variables: {
        phone: phone
      }
    }).then((res: any) => {
      const results = res.data.data.clientPhoneSearch.map((cps: any) => new Client(cps))
      return results
    })
  }
}

export default clientService
